import ApiService from '../api.service'

const UserService = {
    async searchUsers (payload) {
        // console.log(store)
        const url = `/api/User/SearchUsers`
        const requestData = {
            method: 'post',
            url: url,
            data: payload,
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }

    },
    // -------------------user add/edit 
    async getUserEditData (id) {
        const url = `/api/UserEdit/GetUserEditData/${id}`
        const requestData = {
            method: 'post',
            url: url,
            data: {},
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }
    },
    async signUserUp (payload) {
        const url = `/api/Account/AddNewUser`
        const requestData = {
            method: 'post',
            url: url,
            data: payload,
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }
    },
    async updateUser (payload) {
        const url = `/api/Account/UpdateUser`
        const requestData = {
            method: 'post',
            url: url,
            data: payload,
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }
    },
    async activeDeactiveUser (id) {
        const url = `/api/UserEdit/ActiveDeactiveUser/${id}`
        const requestData = {
            method: 'post',
            url: url,
            data: {},
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }
    },
    async resetPassword (email) {
        const url = `/api/Account/ResetPassword?email=${email}`
        const requestData = {
            method: 'post',
            url: url,
            data: {},
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }
    },
    // -------------------end user add/edit 
    
    // ------------------roles related
    async getAllRoles () {
        const url = `/api/UserEdit/GetAllRoles`
        const requestData = {
            method: 'post',
            url: url,
            data: {},
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }
    },
    // ------------------end roles related

    // ------------------- HMTerrAssign data search
    // async searchRepsForWebQuote (zip) {
    //     const url = `/api/User/searchRepsForWebQuote`
    //     const requestData = {
    //         method: 'post',
    //         url: url,
    //         data: zip,
    //     }

    //     try {
    //         const response = await ApiService.customRequest(requestData)
    //         return response.data
    //     } catch (ex) {
    //         throw ex
    //     }
    // },

    // -------------------end  HMTerrAssign data search

    // -------------------initial user, region, territory population
    //payload here is classId for product db data
    async populateInitData (payload) {
        const url = `/api/ItemProdDb/PopulateInitData?classId=${payload}`
        const requestData = {
            method: 'post',
            url: url,
            data: {},
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }
    },
    async importTazData () {
        const url = `/api/TazImport/importTazData`
        const requestData = {
            method: 'post',
            url: url,
            data: {},
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }
    },

    // -------------------end initial user, region, territory population


}

export default UserService